export default __webpack_public_path__ + "405297ccdcd5668cbc3219251e3493c2.jpg";